import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled from "styled-components";

export const RentHivePopup = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const RentHiveHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;

  h3 {
    color: var(--fg-default, rgba(16, 24, 40, 1));

    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
  }

  svg {
    cursor: pointer;
  }
`;

export const RentHiveContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-size: font-size: ${toRem(14)};
  line-height: 20px;
  text-align: center;
    a {
    color: ${COLORS.ACCENT.DEFAULT};
    @media (any-hover: hover){
      &:hover{
        text-decoration: underline;
      }
    }
  
`;

export const RentHiveFooter = styled.div`
  display: flex;
  height: 100%;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 16px;
  margin-top: 30px;
`;
